import Vue from 'vue'
import VueRouter from 'vue-router'
import App from './App.vue'

import store from './store'

import VueI18n from 'vue-i18n'
import translations from './translations'

import VueMoment from 'vue-moment'
import moment from 'moment'
import VueYouTubeEmbed from 'vue-youtube-embed'

import Index from './routes/Index.vue'
import License from './routes/License.vue'
import Login from './routes/Login.vue'
import Logout from './routes/Logout.vue'
import Manage from './routes/Manage.vue'
import ManageInfo from './routes/manage/ManageInfo.vue'
import ManageResources from './routes/manage/ManageResources.vue'
import ManageManuals from './routes/manage/ManageManuals.vue'
import ManageBooks from './routes/manage/ManageBooks.vue'
import ManageFacilitator from './routes/manage/ManageFacilitator.vue'
import ManageVideos from './routes/manage/ManageVideos.vue'
import ManageSetup from './routes/manage/ManageSetup.vue'
import ManagePrintouts from './routes/manage/ManagePrintouts.vue'
import ManageHotspot from './routes/manage/ManageHotspot.vue'
import ManageHTMM from './routes/manage/ManageHTMM.vue'

import ViewUI from 'view-design'
import 'view-design/dist/styles/iview.css'

import 'lato-font/css/lato-font.min.css'

import elementClosest from 'element-closest'
elementClosest(window)

import axios from 'axios'
axios.defaults.withCredentials = true

Vue.config.productionTip = false
Vue.use(VueRouter)
Vue.use(ViewUI)
Vue.use(VueI18n)
Vue.use(VueYouTubeEmbed)

Vue.filter('toCurrency', function (value, currency) {
  if (typeof value !== "number") {
    return value;
  }
  let val = parseFloat(value).toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");
  if (!currency)
    return val.replace('.', ',').replace(',00', '');

  switch (currency) {
    case "usd":
      return "$" + val.replace('.00', '');
    case "inr":
      return "₹" + val.replace('.00', '');
    default:
      return val.replace('.', ',').replace(',00', '');
  }
});

const routes = [
  { path: '/', component: Index },
  { path: '/login', component: Login },
  { path: '/logout', component: Logout },
  { path: '/buy', component: License },
  { path: '/manage', component: Manage,
    children: [
      {path: '', name: 'manage', component: ManageInfo},
      {path: 'books', name: 'books', component: ManageBooks},
      {path: 'resources', name: 'resources', component: ManageResources},
      {path: 'facilitator', name: 'facilitator', component: ManageFacilitator},
      {path: 'manuals', name: 'manuals', component: ManageManuals},
      {path: 'entrepreneurship', name: 'entrepreneurship', component: ManageHTMM},
      {path: 'printouts', name: 'printouts', component: ManagePrintouts},
      {path: 'hotspot', name: 'hotspot', component: ManageHotspot},
      {path: 'setup', name: 'setup', component: ManageSetup},
      {path: 'videos', name: 'videos', component: ManageVideos}
    ]
  }
]


var locale = 'en';
if (["nb_NO", "nn_NO", "no", "nb"].indexOf((navigator.language || navigator.userLanguage)) !== -1) {
  locale = 'nb';
}

const router = new VueRouter({
  mode: 'history',
  base: '/license/',
  routes
})

const i18n = new VueI18n({
  locale: locale,
  fallbackLocale: 'en',
  messages: translations
})

import 'moment/locale/nb'
moment.locale(locale)
Vue.use(VueMoment, {
  moment
})

new Vue({
  router,
  i18n,
  store,
  render: h => h(App)
}).$mount('#app')
